<template>
  <!-- Shaft scroll panel (middle panel) -->
  <HeaderBar :modifiers="['dark', 'sticky']" class="hide-for-medium">
    <router-link
      class="header-bar__title typo-nav-item"
      :to="{ name: 'shaftCondition' }"
      :aria-label="$t('general.back')"
    >
      <UseSvg name="arrow_left" class="icon" />
      <div class="typo-small-title">
        {{ $t(`shafts.element_types.shaft.${$route.params.elementType}`) }}
      </div>
    </router-link>
  </HeaderBar>

  <div class="condition-layout__content" ref="content" @scroll.passive="onScroll">
    <Loader v-if="loading" />

    <!-- Sticky header -->
    <div
      class="shaft-scroll__sticky-header"
      v-if="$route.params.elementType !== 'stations' && !atTop"
      :style="stickyHeaderStyle"
    >
      <div
        class="shaft-scroll shaft-scroll--sticky"
        :style="stickyHeaderContentStyle"
      >
        <div class="shaft-scroll__sets shaft-scroll__sticky">
          <div class="shaft-scroll__grid-row"></div>
          <div class="shaft-scroll__grid-row"></div>
          <div class="shaft-scroll__grid-row typo-tiny">
            {{ $t('shafts.issues.set') }} #
          </div>
        </div>
        <div></div>
        <div class="shaft-scroll__wrapper" v-for="(value, name) in scrollElements" :key="name">
          <div class="shaft-scroll__grid-row">
            <div class="shaft-scroll__element-title">
              {{ $t(`shafts.element_types.shaft.${name}`) }}
            </div>
          </div>

          <!-- Shaft element group container -->
          <div class="shaft-scroll__element-group-container">
            <!-- Shaft element group -->
            <div
              class="shaft-scroll__element-group"
              v-for="shaftElementGroup in value"
              :key="shaftElementGroup.id"
            >
              <!-- Shaft element group title -->
              <div class="shaft-scroll__grid-row">
                <div class="shaft-scroll__element-group-title typo-tiny">
                  {{ shaftElementGroup.name }}
                </div>
              </div>

              <!-- Shaft element group items -->
              <div class="shaft-scroll__element-group-items">
                <!-- Shaft element item -->
                <div
                  class="shaft-scroll__element-group-item"
                  v-for="shaftElementItem in shaftElementGroup.shaft_elements"
                  :key="shaftElementItem.id"
                >
                  <div class="shaft-scroll__grid-row">
                    <div class="shaft-scroll__element-group-title typo-tiny">
                      {{ shaftElementItem.symbol }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div></div>
        <div></div>
      </div>
    </div>

    <div ref="container" class="stations-container scroll-container">
      <div
        class="stations-scroll"
        v-if="$route.params.elementType === 'stations'"
      >
        <div class="stations-scroll__header">
          <div>&nbsp;</div>
          <div class="stations-scroll__header-title">
            {{ $t(`shafts.element_types.shaft.${$route.params.elementType}`) }}
          </div>
        </div>
        <div
          class="stations-scroll__station"
          v-for="station in currectShaftScrollData.stations"
          :key="station.id"
          :id="convertToUnderscore(station.name)"
        >
          <div class="stations-scroll__grid-row">
            <div class="stations-scroll__grid-row-set"></div>
            <div class="dashed stations-scroll__grid-row-label"></div>
            <div class="dashed stations-scroll__grid-row-content">
              <div class="stations-scroll__grid-count">
                <div
                  class="stations-scroll__grid-count-item"
                  v-for="(gridLine, index) in numOfGridColumns(currectShaftScrollData.stations)"
                  :key="index"
                >
                  <div class="stations-scroll__grid-count-item-line"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="stations-scroll__grid-row">
            <div class="stations-scroll__grid-row-set typo-tiny">
              {{ $t('shafts.condition.set') }} {{ station.start_set }}-{{ station.end_set }}
            </div>
            <div class="dashed stations-scroll__grid-row-label">
              <div class="stations-scroll__station-name typo-tiny">
                {{ station.name }} &nbsp; {{ station.depth }}m
              </div>
            </div>
            <div class="dashed stations-scroll__grid-row-content">
              <div class="station-start-1"></div>
              <div class="station-start-2"></div>
            </div>
          </div>
          <div
            class="stations-scroll__grid-row"
            v-for="(member, value) in station.members"
            :key="member.id"
          >
            <div class="stations-scroll__grid-row-set"></div>

            <div class="dashed typo-tiny stations-scroll__grid-row-label">
              <div class="stations-scroll__grid-row-label-text">
                {{ $t(`shafts.element_types.station.${value}`) }}
              </div>
              <div class="stations-scroll__grid-row-label-indicator"></div>
            </div>
            <div class="dashed station__members">
              <router-link
                v-for="(memberItem, index) in member"
                :key="memberItem.id"
                class="shaft-scroll__member"
                aria-label="member"
                :class="`shaft-scroll__member shaft-scroll__member--${memberClasses(memberItem.member_rating)}`"
                activeClass="shaft-scroll__member--active"
                :to="{
                  name: 'shaftScrollDetail',
                  params: {
                    memberId: memberPathStation(memberItem.id, station.name, value, index),

                  },
                }"
              >
              </router-link>
            </div>
          </div>

          <div class="stations-scroll__grid-row">
            <div class="stations-scroll__grid-row-set"></div>
            <div class="dashed stations-scroll__grid-row-label"></div>
            <div class="dashed stations-scroll__grid-row-content">
              <div class="station-end-1"></div>
              <div class="station-end-2"></div>
            </div>
          </div>
          <div class="stations-scroll__grid-row">
            <div class="stations-scroll__grid-row-set"></div>
            <div class="dashed stations-scroll__grid-row-label"></div>
            <div class="dashed stations-scroll__grid-row-content"></div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="!loading && $route.params.elementType !== 'stations'"
      class="shaft-scroll scroll-container"
      @scroll.passive="onScroll"
      ref="scrollElement"
    >
      <!-- Sets -->
      <div class="shaft-scroll__sets">
        <div class="shaft-scroll__grid-row"></div>
        <div class="shaft-scroll__grid-row"></div>
        <div class="shaft-scroll__grid-row typo-tiny">
          {{ $t('shafts.issues.set') }} #
        </div>
        <div
          class="shaft-scroll__set shaft-scroll__grid-row shaft-scroll__grid-row--set"
          v-for="set in currectShaftScrollData.number_of_sets"
          :key="set"
        >
          <div class="shaft-scroll__set-item typo-tiny">
            {{ set }}
          </div>
        </div>
      </div>
      <!-- Left station column -->
      <div class="shaft-scroll__station">
        <div class="shaft-scroll__grid-row"></div>
        <div class="shaft-scroll__grid-row">
          <div class="shaft-scroll__station-set--default shaft-scroll__station-set--top"></div>
        </div>
        <div class="shaft-scroll__grid-row">
          <div class="shaft-scroll__station-set--default"></div>
        </div>
        <div
          v-for="stationSet in currectShaftScrollData.number_of_sets"
          :key="stationSet"
          class="shaft-scroll__grid-row"
        >
          <div class="shaft-scroll__station-set--default"></div>
          <div
            class="shaft-scroll__station-set"
            v-for="set in currectShaftScrollData.station_summary"
            :key="set"
          >
            <div
              class="shaft-scroll__station-set--station"
              v-if="stationSet >= set.start_set && stationSet <= set.end_set"
            >
              &nbsp;
            </div>
            <template
              v-for="stationSetSummary in currectShaftScrollData.station_summary"
              :key="stationSetSummary"
            >
              <div
                class="shaft-scroll__station-start"
                v-if="stationStartOrEnd(stationSetSummary.start_set, stationSet)"
              >
                <div class="station-indicator-part-1-left"></div>
                <div class="station-indicator-part-2-left"></div>
              </div>
              <div
                class="shaft-scroll__station-end"
                v-if="stationStartOrEnd(stationSetSummary.end_set, stationSet)"
              >
                <div class="station-indicator-part-1-left"></div>
                <div class="station-indicator-part-2-left"></div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Shaft main content -->
      <div class="content">
        <div class="shaft-scroll__wrapper" v-for="(value, name) in scrollElements" :key="name">
          <div class="shaft-scroll__grid-row">
            <div class="shaft-scroll__element-title">
              {{ $t(`shafts.element_types.shaft.${name}`) }}
            </div>
          </div>

          <!-- Shaft element group container -->
          <div class="shaft-scroll__element-group-container">
            <!-- Shaft element group -->
            <div
              class="shaft-scroll__element-group"
              v-for="shaftElementGroup in value"
              :key="shaftElementGroup.id"
            >
              <!-- Shaft element group title -->
              <div class="shaft-scroll__grid-row">
                <div class="shaft-scroll__element-group-title typo-tiny">
                  {{ shaftElementGroup.name }}
                </div>
              </div>

              <!-- Shaft element group items -->
              <div class="shaft-scroll__element-group-items">
                <!-- Shaft element item -->
                <div
                  class="shaft-scroll__element-group-item"
                  v-for="shaftElementItem in shaftElementGroup.shaft_elements"
                  :key="shaftElementItem.id"
                >
                  <div class="shaft-scroll__grid-row">
                    <div class="shaft-scroll__element-group-title typo-tiny">
                      {{ shaftElementItem.symbol }}
                    </div>
                  </div>
                  <!-- range wrapper -->
                  <div class="set-range">
                    <div
                      class="shaft-scroll__grid-row"
                      v-for="guideset in currectShaftScrollData.number_of_sets"
                      :key="guideset"
                    >
                    </div>
                    <!-- Range container. spans element type start set to end set -->
                    <div
                      class="set-range__container"
                      :style="gridSpan(shaftElementItem)"
                    >
                      <template v-for="(member, index) in shaftElementItem.members" :key="index">
                        <!-- Guide elements -->
                        <div v-if="$route.params.elementType === 'guides'">
                          <div :class="elementTypeClasses" v-if="index%2 !== 0">
                            <router-link
                              @mouseover="onMemberHover(shaftElementItem, index)"
                              @mouseleave="activeElementType = null"
                              aria-label="member"
                              :class="`shaft-scroll__member shaft-scroll__member--${memberClasses(member.member_rating)}`"
                              activeClass="shaft-scroll__member--active"
                              :to="{
                                name: 'shaftScrollDetail',
                                params: {
                                  memberId: memberPath(member.id, shaftElementItem.name, index)
                                },
                              }"
                            >
                            </router-link>
                          </div>
                          <!-- Last item in a guide -->
                          <div class="shaft-scroll__grid-row shaft-scroll__grid-row--member" v-if="index >= currectShaftScrollData.number_of_sets">

                            <router-link
                              @mouseover="onMemberHover(shaftElementItem, index)"
                              @mouseleave="activeElementType = null"
                              aria-label="member"
                              :class="`shaft-scroll__member shaft-scroll__member--${memberClasses(member.member_rating)}`"
                              activeClass="shaft-scroll__member--active"
                              :to="{
                                name: 'shaftScrollDetail',
                                params: {
                                  memberId: memberPath(member.id, shaftElementItem.name, index)
                                },
                              }"
                            >
                            </router-link>
                          </div>
                        </div>
                        <!-- everything else other than a guide element type -->
                        <div v-else>

                          <div :class="elementTypeClasses">
                            <router-link
                              @mouseover="onMemberHover(shaftElementItem, index)"
                              @mouseleave="activeElementType = null"
                              aria-label="member"
                              :class="`shaft-scroll__member shaft-scroll__member--${memberClasses(member.member_rating)}`"
                              activeClass="shaft-scroll__member--active"
                              :to="{
                                name: 'shaftScrollDetail',
                                params: {
                                  memberId: memberPath(member.id, shaftElementItem.name, index)
                                },
                              }"
                            >
                            </router-link>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Right station column -->
      <div class="shaft-scroll__station">
        <div class="shaft-scroll__grid-row"></div>
        <div class="shaft-scroll__grid-row">
          <div class="shaft-scroll__station-set--default shaft-scroll__station-set--top"></div>
        </div>
        <div class="shaft-scroll__grid-row">
          <div class="shaft-scroll__station-set--default"></div>
        </div>
        <div
          v-for="stationSet in currectShaftScrollData.number_of_sets"
          :key="stationSet"
          class="shaft-scroll__grid-row"
        >
          <div class="shaft-scroll__station-set--default"></div>
          <div
            class="shaft-scroll__station-set"
            v-for="stationSetSummary in currectShaftScrollData.station_summary"
            :key="stationSetSummary"
          >
            <div
              class="shaft-scroll__station-set--station"
              v-if="stationSet >= stationSetSummary.start_set && stationSet <= stationSetSummary.end_set"
            >
              &nbsp;
            </div>
          </div>
        </div>
      </div>

      <!-- Right column -->
      <div class="shaft-scroll__station shaft-scroll__station--right">
        <div class="shaft-scroll__grid-row"></div>
        <div class="shaft-scroll__grid-row"></div>
        <div class="shaft-scroll__grid-row"></div>
        <div
          v-for="stationSet in currectShaftScrollData.number_of_sets"
          :key="stationSet"
          class="shaft-scroll__grid-row shaft-scroll__grid-row-rule"
        >
          <template
            v-for="stationSetSummary in currectShaftScrollData.station_summary"
            :key="stationSetSummary"
          >
            <div
              class="shaft-scroll__station-start"
              v-if="stationStartOrEnd(stationSetSummary.start_set, stationSet)"
            >
              <div class="station-indicator-part-1"></div>
              <div class="station-indicator-part-2"></div>
              <div class="station-indicator-part-3">
                <router-link
                  :to="{
                    name: 'shaftScroll',
                    params: { elementType: 'stations' },
                    query: { station: convertToUnderscore(stationSetSummary.name)} }"
                >
                  <StationIconSVG />
                </router-link>
                <div class="shaft-scroll__station-tool-tip typo-smallish">
                  <div>{{ stationSetSummary.name }}</div>
                  <div>{{ stationSetSummary.depth }}m</div>
                  <div class="shaft-scroll__station-tool-tip-arrow"></div>
                </div>
              </div>
            </div>
            <div
              class="shaft-scroll__station-end"
              v-if="stationStartOrEnd(stationSetSummary.end_set, stationSet)"
            >
              <div class="station-indicator-part-1"></div>
              <div class="station-indicator-part-2"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

  <!-- Shaft element member detail panel (right panel) -->
  <div :class="{ 'condition-layout__right': true, 'show-for-medium': !memberId }">
    <Loader v-if="loadingDiagram || !shaft" />
    <MemberDetails
      v-else
      :elementType="elementType"
      :organisationId="organisationId"
      :shaftId="shaftId"
      :shaftDiagramData="shaftDiagramData"
      :shaftDiagramVisible="$route.params.elementType !== 'stations'"
    />
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, ref, watch, nextTick } from 'vue';
import { useRoute } from 'vue-router';
import useAjax from '@/functions/use_ajax';
import { useShaft } from '@/functions/use_remote_object';
import { convertToUnderscore } from '@/functions/convert_to_underscore';

import HeaderBar from '@/components/generic/header_bar.vue';
import MemberDetails from '@/components/shafts/condition/member_details.vue';
import UseSvg from '@/components/generic/use_svg.vue';
import Loader from '@/components/generic/loader.vue';
import StationIconSVG from '@/images/station-icon.svg';

const props = defineProps({
  organisationId: { type: String, required: true },
  shaftId: { type: String, required: true },
  elementType: { type: String, required: true },
  memberId: { type: String, required: false, default: null },
});

const ajax = useAjax();
const route = useRoute();
const shaft = useShaft(props);

const currectShaftScrollData = ref({});
const loading = ref(false);
const scrollElements = ref({});
const loadingDiagram = ref(null);
const crossSectionElements = ref(null);
const activeElementType = ref(null);
const container = ref(null);
const currentlySelectedMember = ref(null);
const atTop = ref(true);
const scrollLeft = ref(0);
const scrollTop = ref(0);
const stickyHeaderWidth = ref(0);
const stickyHeaderContentWidth = ref(0);
const scrollElement = ref(null);
const content = ref(null);

const stickyHeaderStyle = computed(() => {
  let style = {
    top: `${scrollTop.value}px`,
    width: `${stickyHeaderWidth.value}px`
  };
  if (stickyHeaderWidth.value > stickyHeaderContentWidth.value) {
    style.paddingRight = `${stickyHeaderWidth.value - stickyHeaderContentWidth.value}px`;
  }
  return style;
});

const stickyHeaderContentStyle = computed(() => {
  return { left: `-${scrollLeft.value}px` };
});

onMounted(() => {
  loadShaftElements();
  loadShaftDiagram();
  updateStickyHeaderWidth();

  window.addEventListener('resize', updateStickyHeaderWidth, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateStickyHeaderWidth);
  window.removeEventListener('resize', onScroll);
});

watch(() => props.elementType, async () => {
  await nextTick();
  atTop.value = true;
});

/**
 * Get shaft element type
 */
const loadShaftElements = async () => {
  loading.value = true;

  let { ok, data } = await ajax(`/organisations/${props.organisationId}/shafts/${props.shaftId}/condition/${props.elementType}`);

  if (ok) {
    currectShaftScrollData.value = data;

    scrollElements.value = Object.fromEntries(
      Object.entries(currectShaftScrollData.value).filter(([key]) =>
        props.elementType.includes(key)
      )
    );
  }

  loading.value = false;

  nextTick(scrollToStation);
  nextTick(scrollToActiveMember);
  nextTick(updateStickyHeaderWidth);
};

const scrollToStation = () => {
  if (route.query.station) {
    const station = document.getElementById(route.query.station).offsetTop;
    container.value.scrollTo({ top: station, behavior: 'smooth' });
  }
};

const scrollToActiveMember = () => {
  currentlySelectedMember.value = document.querySelector('.shaft-scroll__member--active');

  if (currentlySelectedMember.value) {
    currentlySelectedMember.value.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
  }
};

/**
 * Get shaft cross-section diagram data
 */
const loadShaftDiagram = async () => {
  loadingDiagram.value = true;

  let { ok, data } = await ajax(`/organisations/${props.organisationId}/shafts/${props.shaftId}/dashboard/geometry`);

  if (ok) {
    crossSectionElements.value = data;
  }

  loadingDiagram.value = false;
};

watch(() => props.elementType, loadShaftElements);

const stationStartOrEnd = (summary, set) => {
  return summary === set;
};

const memberPath = (id, element, member) => {
  let elementName = convertToUnderscore(element);

  if(id === null) {
    return `no_detail_${elementName}_${member}`;
  } else {
    return id;
  }
};

const memberPathStation = (id, station, element, member) => {
  let stationName = convertToUnderscore(station);
  let elementName = convertToUnderscore(element);

  if(id === null) {
    return `no_detail_${stationName}_${elementName}_${member}`;
  } else {
    return id;
  }
};

const memberClasses = (rating) =>
  isNaN(rating) ? '' : rating;

const numOfGridColumns = (items) => {
  let gridCount = 0;

  items.forEach((element) => {
    for (const key in element.members) {
      if (element.members[key].length > gridCount) {
        gridCount = element.members[key].length;
      }
    }
  });
  return gridCount;
};

/**
 * When hovering on a member, it stores
 * the member and set number which will
 * be used in the shaftDiagramData function
 */
const onMemberHover = (item, set) => {
  activeElementType.value = {
    name: item.name,
    symbol: item.symbol,
    id: item.id,
    set_number: set,
  };
};

/**
 * Data for the shaft diagram,
 * passed through the MemberDetails component
 */
const shaftDiagramData = computed(() => {
  return {
    elements: crossSectionElements.value,
    shape: shaft.value?.shape,
    activeItem: activeElementType.value,
  };
});

/**
 * checks if element type is guide to apply different height
 */
const elementTypeClasses = computed(() => {
  let isGuide = props.elementType === 'guides';
  return {
    'shaft-scroll__grid-row--member': true,
    'shaft-scroll__grid-row': !isGuide,
    'shaft-scroll__grid-row--member-span-2': isGuide,
  }
});

/**
 * Works out the spanning range for the start and end set
 */
const gridSpan = (element) => {
  return `grid-row: ${element.start_set} / ${element.end_set + 1}`;
};

function onScroll(event) {
  if (!content.value || !scrollElement.value) return;

  atTop.value = scrollElement.value.scrollTop === 0 && content.value.scrollTop === 0;
  scrollLeft.value = scrollElement.value.scrollLeft;
  scrollTop.value = content.value.scrollTop;
}

function updateStickyHeaderWidth() {
  if (!content.value || !scrollElement.value) return;

  let contentWidth = content.value.clientWidth;
  let contentScrollWidth = content.value.scrollWidth;
  let scrollWidth = scrollElement.value.scrollWidth;
  if (contentWidth < scrollWidth) {
    stickyHeaderContentWidth.value = scrollWidth;
  } else {
    stickyHeaderContentWidth.value = contentWidth;
  }
  stickyHeaderWidth.value = contentScrollWidth;
}
</script>
